import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router'

import withNav from 'containers/withNav'
import { Relative } from 'ui/styles/utils'
import Some from '../Some'

import Nav from './Nav'

const Wrapper = styled.div`
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  width: 100%;
  padding: ${props => props.theme.navHeight}px 20px 20px;

  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  background-color: #fff;
  color: ${props => props.theme.colors.tones.darker};
  opacity: ${props => props.visible ? 1 : 0};
  transform: translateY(${props => props.visible ? 0 : -50}%);
  z-index: 1;
  pointer-events: ${props => props.visible ? 'auto' : 'none'};

  transition: all 800ms;

  ${props => !props.visible && css`
    * {
      transition-delay: 0ms !important;
    }
  `}
`

class Overlay extends Component {
  render() {
    const { visible, mainNav, secondaryNav } = this.props

    return (
      <Wrapper visible={visible}>
        <Relative fillHeight>
          <Nav
            items={mainNav}
            visible={visible}
          />
        </Relative>
      </Wrapper>
    )
  }
}

export default compose(
  withRouter,
  withNav('MAIN_NAV', 'mainNav'),
  //withNav('SECONDARY_NAV', 'secondaryNav')
)(Overlay)



// WEBPACK FOOTER //
// ./src/ui/components/Navigation/Overlay/index.js